import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

function MainLayout() {
  return (
    <main className="d-flex flex-row" style={{ height: "100vh" }}>
      <Sidebar />
      <div className="content">
        <Outlet />
      </div>
    </main>
  );
}

export default MainLayout;
